module.exports = __webpack_public_path__ + "static/img/jcyy-content-tab-1.9b16295.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/chartTexeraJc/jcyy-content-tab-1.png
// module id = NYDM
// module chunks = 34